import { Col, Row } from "react-bootstrap";
import { NFIntInput } from "../../../../Shared/NewForms/NFIntInput";
import { NFLookupCurrency } from "../../../../Shared/NewForms/NFlookupCurrency";
import { useTranslation } from "react-i18next";

const IncomingBanksCurrencyConversionDetail = () => {
  const { t } = useTranslation();

  return (
    <Row>
      <Col>
        <NFIntInput fieldName={"amountWithVat"} title={t("InTheAmountOf")} required />
      </Col>
      <Col>
        <NFLookupCurrency fieldName={"convertedCurrencyId"} title={t("ConvertedCurrency")} required />
      </Col>
    </Row>
  );
};

export default IncomingBanksCurrencyConversionDetail;
